import { render, staticRenderFns } from "./StaticInputsForm.vue?vue&type=template&id=a16e5fd0&scoped=true&"
import script from "./StaticInputsForm.vue?vue&type=script&lang=js&"
export * from "./StaticInputsForm.vue?vue&type=script&lang=js&"
import style0 from "./StaticInputsForm.vue?vue&type=style&index=0&id=a16e5fd0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16e5fd0",
  null
  
)

export default component.exports